import React, {Component} from 'react';
import PropTypes from 'prop-types';

class SimplifiedCheckbox extends Component {
  render() {
    const style = this.props.styling ? this.props.styling : {backgroundColor: '#337AB71A', padding: '10px 0px 10px 0px', margin: '5px'};
    return (
      <div className={'col-md-2'}>
        <div style={style}>
          <input
            type="checkbox"
            id={this.props.fieldId}
            disabled={this.props.disabled || false}
            data-user={this.props.data}
            onChange={this.props.onChange}
            name={this.props.fieldId}
            checked={this.props.value}
            style={{display: 'block', margin: 'auto'}}
          />
        </div>
      </div>
    );
  }
}

SimplifiedCheckbox.propTypes = {
  fieldId: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func,
  data: PropTypes.number,
  disabled: PropTypes.bool,
  styling: PropTypes.object,
};
SimplifiedCheckbox.defaultProps = {};

export default SimplifiedCheckbox;
